module.exports = __webpack_public_path__ + "static/media/privacy.8f507e1f.svg";